import React, { useCallback } from 'react';

import { watchLinks } from '../../defaultLinks';
import BaseMenu from '../BaseMenu';
import BaseMenuSection from '../BaseMenuSection';

interface WatchMenuProps {
  onClickLink?: (clickProperties: any, closeMobileMenu: boolean) => void;
}

const WatchMenu = ({ onClickLink }: WatchMenuProps) => {
  const onClickHandler = useCallback(
    (properties: any, closeMobileMenu: boolean) => {
      if (onClickLink) {
        onClickLink(
          {
            name: 'Clicked Main Nav',
            properties: {
              ...properties,
              tabName: 'Watch',
              clickEndLocation: 'Watch',
            },
          },
          closeMobileMenu,
        );
      }
    },
    [onClickLink],
  );

  return (
    <BaseMenu testId="watch-menu">
      <BaseMenuSection links={watchLinks} onClick={onClickHandler} />
    </BaseMenu>
  );
};

export default WatchMenu;
